import { render, staticRenderFns } from "./RangeColorInfo.vue?vue&type=template&id=f14715a0&scoped=true&functional=true"
import script from "./RangeColorInfo.vue?vue&type=script&lang=js"
export * from "./RangeColorInfo.vue?vue&type=script&lang=js"
import style0 from "./RangeColorInfo.vue?vue&type=style&index=0&id=f14715a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "f14715a0",
  null
  
)

export default component.exports